import axios from 'axios';
import { IReview } from '@/entities/Activity/domain/Review.domain';

export async function fetchViatorReviews(productCode: string): Promise<IReview[]> {
    const { data } = await axios.get<IReview[]>(`/api/viator-reviews?productCode=${productCode}`);
    return data;
}
